// Topo da página do empreendimento nos sites com `modelo_pagina_imovel` 1 (e padrão): banner escurecido com
// a faixa do título (welcome/WelcomePiecesProperties.tsx) e, abaixo do breadcrumb, a grade de 2 fotos
// (gallery/GalleryPiecesProperties.tsx). O cabeçalho do site continua o WelcomePiecesProperties2 da página;
// o logo/menu sobreposto ao banner do imóvel modelo 1 não é copiado.
import Image from 'next/image';
import { MdTag } from 'react-icons/md';
import CompartilharEmpreendimento from './CompartilharEmpreendimento';
import type { FotoTopoEmpreendimento } from './TopoPainelEmpreendimento';
import styles from './EmpreendimentoDetalhe.module.css';

export const FaixaTituloEmpreendimento = ({
    titulo,
    nome,
    situacao,
    banner,
}: {
    titulo: string;
    nome: string;
    situacao: string;
    banner: string;
}) => (
    <section id="empreendimento" className={styles.faixaBanner}>
        <Image src={banner} alt="" fill priority sizes="100vw" className={styles.faixaBannerImg} />
        {/* O imóvel modelo 1 não tem compartilhar no topo; no empreendimento ele fica no canto do banner. */}
        <CompartilharEmpreendimento titulo={titulo} nome={nome} className={styles.baloesTopo} />
        <div className={styles.faixaTitulo}>
            {/* H1 ÚNICO da página: nome + cidade/UF é a consulta que se quer ranquear. */}
            <h1 className={styles.faixaH1} data-gfm>
                {titulo}
            </h1>
            <div className={styles.faixaSubtitulo}>
                <MdTag size={18} color="white" />
                {situacao}
            </div>
        </div>
    </section>
);

export const GradeFotosEmpreendimento = ({
    nome,
    fotos,
    capa,
    onAbrirFoto,
}: {
    nome: string;
    fotos: FotoTopoEmpreendimento[];
    capa: string;
    onAbrirFoto: (index: number) => void;
}) => {
    const itens = fotos.length > 0 ? fotos.slice(0, 2) : [{ id: 0, url_foto: capa, descricao: null }];
    const restantes = fotos.length - 2;

    return (
        <div className={styles.gradeTopo}>
            {itens.map((foto, index) => (
                <button
                    key={`${foto.id}-${index}`}
                    type="button"
                    className={styles.gradeItem}
                    onClick={() => onAbrirFoto(index)}
                    aria-label={`Abrir foto ${index + 1} de ${nome}`}
                >
                    <Image
                        src={foto.url_foto}
                        alt={foto.descricao || `Foto ${index + 1} de ${nome}`}
                        fill
                        sizes="(max-width: 900px) 95vw, 48vw"
                        priority={index === 0}
                        className={styles.gradeImg}
                    />
                    {index === 1 && restantes > 0 ? (
                        <span className={`${styles.gradeOverlay} ${styles.gradeOverlayFixo}`}>+{restantes}</span>
                    ) : (
                        <span className={styles.gradeOverlay}>+</span>
                    )}
                </button>
            ))}
        </div>
    );
};

// Preço logo abaixo das fotos, no lugar do "Cod./Venda" do imóvel modelo 1 (DetailsPiecesProperties.tsx:1237-1289).
export const PrecoFaixaEmpreendimento = ({
    precoInicial,
    faixaPreco,
    faixaArea,
}: {
    precoInicial: string;
    faixaPreco: string;
    faixaArea: string;
}) => {
    const mostrarFaixaPreco = / a /.test(faixaPreco);
    return (
        <div className={styles.precoBloco}>
            <p className={styles.precoValor} data-gfm1>
                {precoInicial ? `A partir de: ${precoInicial}` : 'Consulte valores'}
            </p>
            {mostrarFaixaPreco || faixaArea ? (
                <p className={styles.precoInfo}>
                    {[mostrarFaixaPreco ? `Faixa de preço: ${faixaPreco}` : '', faixaArea ? `Área privativa: ${faixaArea}` : '']
                        .filter(Boolean)
                        .join(' · ')}
                </p>
            ) : null}
        </div>
    );
};
